<template>
  <div id="cart" uk-modal @shown="focusDialog">
    <div
      ref="dialog"
      class="uk-margin-auto-vertical uk-modal-dialog uk-modal-body"
      role="dialog"
      aria-modal="true"
      :aria-label="standardProject ? 'Cart' : 'Order Summary'"
      tabindex="-1"
    >
      <button
        class="uk-modal-close-outside"
        type="button"
        aria-label="Close"
        uk-close
      ></button>
      <div class="uk-grid">
        <div class="uk-width-1-2">
          <h2>
            <span v-if="standardProject">Cart</span>
            <span v-else>Order Summary</span>
          </h2>
        </div>
        <div class="uk-width-1-2 cart-clear-container">
          <button
            v-if="project.swatches.length > 0 || project.cart.length > 0"
            class="uk-button uk-button-default uk-align-right cart-clear"
            @click="clearCart"
          >
            Clear <span v-if="standardProject">cart</span>
            <span v-else>summary</span>
          </button>
        </div>
      </div>
      <div v-if="project.cart.length > 0" uk-grid class="uk-grid-small">
        <div
          v-for="(item, index) in pricedCart"
          :key="`item${index}`"
          class="uk-width-1-1"
        >
          <div
            class="uk-card uk-card-default uk-card-body uk-card-small uk-width-1-1"
          >
            <div uk-grid class="uk-grid-small uk-flex-middle">
              <div class="uk-width-1-3@m uk-width-1-1">
                <img
                  :src="item.productData.proofImage"
                  :alt="
                    item.productData.productType +
                      ' proof ' +
                      item.productData.proofID
                  "
                />
              </div>
              <div class="uk-width-1-3@m uk-width-1-1">
                <h3 class="uk-margin-small">
                  {{ item.productData.productType }}
                </h3>
                <div class="uk-margin-small">
                  <div
                    v-for="(key, value) in filterFirst(item.variantSelections)"
                    :key="value"
                  >
                    {{ value.charAt(0).toUpperCase() + value.slice(1) }}:
                    {{ key }}
                  </div>
                </div>
                <p class="uk-margin-small">
                  ID: {{ item.productData.proofID }}
                </p>
              </div>

              <div class="uk-width-expand">
                <div class="uk-margin-small">
                  <input
                    v-model.number="item.quantity"
                    :aria-label="
                      'Quantity of ' + item.productData.productType
                    "
                    class="uk-input"
                    type="number"
                    min="1"
                  />
                </div>
              </div>
              <div class="uk-width-auto">
                <div class="uk-margin-small">
                  <span
                    class="uk-margin-small-right"
                    uk-icon="close"
                    role="button"
                    tabindex="0"
                    :aria-label="
                      'Remove ' + item.productData.productType + ' from cart'
                    "
                    @click="removeItem(index)"
                    @keydown.enter.prevent="removeItem(index)"
                    @keydown.space.prevent="removeItem(index)"
                  ></span>
                </div>
              </div>
              <template v-if="standardProject">
                <div class="uk-width-1-3@m uk-width-1-1"></div>
                <div class="uk-width-1-3@m uk-width-1-2">
                  <p class="uk-text-right@m uk-margin">
                    {{ item.quantity }} x {{ item.unitPrice | money }} ea
                  </p>
                </div>
                <div class="uk-width-1-3@m uk-width-1-2">
                  <p class="uk-text-bold uk-text-right">
                    {{ item.lineItemTotal | money }}
                  </p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="project.swatches.length > 0"
        class="uk-width-1-1 uk-margin-small-top"
      >
        <h3 class="uk-margin-small">Swatches</h3>
        <div
          uk-grid
          class="uk-grid-small uk-child-width-1-3@m uk-child-width-1-2"
        >
          <div
            v-for="(swatch, index) in project.swatches"
            :key="`swatch${index}`"
          >
            <div>
              <div class="uk-card uk-card-default uk-card-body uk-card-small">
                <img :src="swatch.proofImage" alt />
                <span
                  class="uk-position-top-right uk-position-small"
                  uk-icon="close"
                  @click="removeSwatch(index)"
                ></span>
                <p class="uk-text-break">
                  {{ swatch.proofID }}
                  <br />
                  {{ swatch.productType }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="project.cart.length == 0 && project.swatches.length == 0"
        class="uk-width-1-1 uk-margin-small-top"
      >
        <div
          class="uk-card uk-card-default uk-card-body uk-card-small uk-width-1-1"
        >
          <p class="uk-text-center">
            No items in your
            <span v-if="standardProject">cart</span
            ><span v-else>order summary</span>
          </p>
        </div>
      </div>
      <!-- // Discount form
      <div
        class="uk-card uk-card-default uk-card-body uk-card-small uk-width-1-1 uk-margin-small-top uk-flex uk-flex-between uk-flex-wrap"
      >

        <form
          id="discountForm"
          class="uk-form uk-width-1-1 uk-form-horizontal"
          @submit="addDiscount($event)"
        >
          <label class="uk-form-label uk-text-default" for="discount"
            >Discount Code</label
          >
          <div class="uk-form-controls">
            <input class="uk-input" type="text" id="discount" />
            <button type="submit" class="uk-form-submit">Save</button>
          </div>
        </form>
        <span
          :class="{ 'uk-hidden': !discountError }"
          class="uk-alert
          uk-width-1-1
          uk-text-small
          uk-text-center
          uk-alert-danger
          uk-margin-small"
          >Discount code invalid. Please try again.</span
        >
      </div>
-->

      <div
        v-if="showPackagingSection"
        class="uk-card uk-card-default uk-card-body uk-card-small uk-width-1-1 uk-margin"
      >
        <h3 class="uk-margin-small">
          {{ settings.packageSelectionSectionTitle }}
        </h3>
        <div class="uk-grid uk-child-width-1-2">
          <div
            class="packaging-option uk-first-column uk-grid-item uk-flex
          uk-flex-column uk-flex-stretch"
            @click="selectPackage('minimal', $event)"
          >
            <img
              src="../../assets/minimal_packaging_new.png"
              alt
              width="100%"
            />
            <div class="uk-margin-small-top">
              <p class="uk-text-bold uk-text-left uk-margin-remove-bottom">
                {{ settings.minimalPackagingTitle }}
              </p>
              <p class="uk-text-bold uk-text-left uk-margin-remove-top">
                {{ settings.minimalPackagingSubtitle }}
              </p>
            </div>
            <div>
              <p class="uk-text-left uk-text-small">
                {{ settings.minimalPackagingDescription }}
              </p>
            </div>
            <div>
              <p
                class="uk-text-left uk-text-xsmall uk-text-italic uk-text-light"
              >
                {{ settings.minimalPackagingClarification }}
              </p>
            </div>
            <div class="uk-flex uk-flex-middle uk-flex-left">
              <input
                class="uk-checkbox"
                type="checkbox"
                ref="minimal"
                :aria-label="settings.minimalPackagingTitle"
                :checked="false"
                :value="false"
              />
              <p class="uk-text-bold uk-margin-small-left">
                {{
                  settings.minimalPackagingCost == 0
                    ? "Free"
                    : `$${settings.minimalPackagingCost}`
                }}
              </p>
            </div>
          </div>
          <div
            class="packaging-option packaging-option-second uk-grid-item
          uk-grid-item-match uk-flex uk-flex-column uk-flex-stretch"
            @click="selectPackage('giftBox', $event)"
          >
            <img src="./../../assets/kraft_boxes_new.png" alt width="100%" />
            <div class="uk-margin-small-top">
              <p class="uk-text-bold uk-text-left uk-margin-remove-bottom">
                {{ settings.individualPackagingTitle }}
              </p>
              <p class="uk-text-bold uk-text-left uk-margin-remove-top">
                ${{ settings.individualPackagingCost.toFixed(2) }}/item
              </p>
            </div>
            <div>
              <p class="uk-text-left uk-text-small">
                {{ settings.individualPackagingDescription }}
              </p>
            </div>
            <div>
              <p
                class="uk-text-left uk-text-xsmall uk-text-italic uk-text-light"
              >
                {{ settings.individualPackagingClarification }}
              </p>
            </div>
            <div
              class="uk-flex uk-flex-middle uk-flex-between uk-margin-remove-top"
            >
              <input
                class="uk-checkbox"
                type="checkbox"
                ref="giftBox"
                :aria-label="settings.individualPackagingTitle"
                :checked="false"
                :value="false"
              />
              <p class="uk-text-bold">
                Total:
              </p>
              <p class="uk-text-bold">
                ${{ individualPackagingCost.toFixed(2) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="project.cart.length > 0 || project.swatches.length > 0"
        class="uk-card uk-card-default uk-card-body uk-card-small uk-width-1-1
      uk-margin"
      >
        <div uk-grid class="uk-grid-small">
          <div
            class="uk-alert-danger uk-padding-small"
            v-if="showSwatchWarning"
          >
            <p class="uk-text-danger uk-text-italic">
              {{ this.settings.swatchAndProductNoticeFirstLine }}
            </p>
            <p class="uk-text-danger uk-text-italic">
              {{ this.settings.swatchAndProductNoticeSecondLine }}
            </p>
          </div>
          <div v-if="project.swatches.length > 0" class="uk-width-2-3">
            <p class="uk-text-right">Swatches:</p>
          </div>
          <div
            :key="swatchShippingOption"
            v-if="project.swatches.length > 0"
            class="uk-width-1-3"
          >
            <p class="uk-text-right">{{ swatchPriceLabel }}</p>
          </div>
          <div
            v-if="showSwatchFulfillmentSection"
            class="uk-grid-collapse uk-width-2-3 radio-container"
            uk-grid
          >
            <label class="uk-margin-small-bottom">
              <input
                class="uk-radio"
                type="radio"
                name="shipping"
                value="physical"
                @change="onSwatchShippingSelect($event)"
              />
              {{ this.settings.swatchShippingLabel }}</label
            >
            <label>
              <input
                class="uk-radio"
                type="radio"
                name="shipping"
                value="digital"
                @change="onSwatchShippingSelect($event)"
              />
              {{ this.settings.swatchDigitalLabel }}</label
            >
          </div>
          <div
            v-if="project.priceAdjustment.label && project.cart.length > 0"
            class="uk-width-2-3"
          >
            <p class="uk-text-right">{{ project.priceAdjustment.label }}</p>
          </div>
          <div
            v-if="project.priceAdjustment.label && project.cart.length > 0"
            class="uk-width-1-3"
          >
            <p class="uk-text-right">
              {{ project.priceAdjustment.amount | money }}
            </p>
          </div>
          <div v-if="project.cart.length > 0" class="uk-width-2-3">
            <p class="uk-text-right">Set Up Charge:</p>
          </div>
          <div v-if="project.cart.length > 0" class="uk-width-1-3">
            <p class="uk-text-right">{{ project.setupCharge | money }}</p>
          </div>
          <div v-if="project.cart.length > 0" class="uk-width-2-3">
            <p class="uk-text-right">{{ settings.packagingSubtotalLabel }}:</p>
          </div>
          <div v-if="project.cart.length > 0" class="uk-width-1-3">
            <p class="uk-text-right">
              ${{ selectedPackagingOption.cost.toFixed(2) }}
            </p>
          </div>
          <div v-if="discountsEnabled" class="uk-width-2-3">
            <p
              class="uk-text-right"
              :style="{ color: discountSettings.discountCartLabelColor.value }"
            >
              {{ discountSettings.discountCartLabel }}: <br />
              <span
                class="uk-text-italic discount-subheading-label"
                :style="{
                  color: discountSettings.discountSubheadingCartColor.value
                }"
                >{{ discountThresholdCalculationRenderer }}</span
              >
            </p>
          </div>
          <div v-if="discountsEnabled" class="uk-width-1-3">
            <p
              class="uk-text-right"
              :style="{ color: discountSettings.discountAmountCartColor.value }"
              :key="discountCalculation"
            >
              -{{ discountCalculation | money }}
            </p>
          </div>
          <div v-if="project.type != 'Distributor'" class="uk-width-2-3">
            <p v-if="!project.customShipping.label" class="uk-text-right">
              Shipping and Tax:
            </p>
            <p v-if="project.customShipping.label" class="uk-text-right">
              Shipping ({{ project.customShipping.label }}):
            </p>
          </div>
          <div v-if="project.type != 'Distributor'" class="uk-width-1-3">
            <p v-if="!project.customShipping.label" class="uk-text-right">
              Calculated at checkout
            </p>
            <p v-if="project.customShipping.label" class="uk-text-right">
              {{ project.customShipping.amount | money }}
            </p>
          </div>
          <template v-if="standardProject">
            <div class="uk-width-2-3">
              <p class="uk-text-bold uk-text-right">Subtotal:</p>
            </div>
            <div class="uk-width-1-3">
              <p class="uk-text-bold uk-text-right" :key="subtotalCalculation">
                {{ subtotalCalculation | money }}
              </p>
            </div>
          </template>
          <div class="uk-width-1-2"></div>
          <div v-if="standardProject" class="uk-width-1-2@m uk-width-1-1">
            <p
              v-if="showPackagingCheckoutError"
              class="uk-text-small uk-text-danger uk-text-italic"
            >
              {{ settings.noPackagingSelectedError }}
            </p>
            <p
              v-if="showSwatchCheckoutError"
              class="uk-text-small uk-text-danger uk-text-italic"
            >
              {{ settings.noSwatchSelectedError }}
            </p>
            <button
              class="uk-button uk-button-primary uk-width-1-1"
              @click="createDraftOrder"
            >
              Check out
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import ProjectsService from "@/services/ProjectsService";

export default {
  name: "Cart",
  filters: {
    money: function(value) {
      return "$" + Number(value).toFixed(2);
    }
  },
  props: [
    "project",
    "pricingInfo",
    "data",
    "discount",
    "discountError",
    "discountCode",
    "settings",
    "discountSettings"
  ],
  data() {
    return {
      cartLink: "",
      shopifiedCart: [],
      subTotal: this.pricingInfo.subTotal,
      selectedPackagingOption: {
        name: "minimal",
        cost: 0,
        selectionMade: false
      },
      showPackagingCheckoutError: false,
      swatchShippingOption: "",
      showSwatchCheckoutError: false
    };
  },
  computed: {
    standardProject() {
      return this.project.type !== "Distributor";
    },
    pricedCart() {
      let cart = [];
      if (this.project.type == "Distributor") {
        for (const item of this.project.cart) {
          item.unitPrice = 0;
          item.basePrice = 0;
          item.lineItemTotal = item.unitPrice * item.quantity;
          cart.push(item);
        }
      } else {
        for (let i = 0; i < this.project.cart.length; i++) {
          let item = this.project.cart[i];
          const type = item.productData.productType;
          // 1. Get variant selections (if they exist)
          const currentProduct = this.data.filter(p => p.productType == type);
          let v = "";
          let option = "";
          const productOptions = currentProduct[0].sampleProductData.options;
          if (currentProduct[0].customPricing) {
            const options = currentProduct[0].variantMapping;
            for (const option of productOptions) {
              v += item.variantSelections[_.camelCase(option.name)];
              if (
                productOptions.indexOf(option) !==
                productOptions.length - 1
              ) {
                v += " / ";
              }
            }
            const arr = options && options.filter(vv => vv.name == v);
            option = arr.length && arr[0].firebaseId;
            option = option.charAt(0).toUpperCase() + option.slice(1);
            item.unitPrice = this.pricingInfo.unitPrice[
              _.camelCase(type) + option.replaceAll('"', "")
            ];
            item.basePrice = this.pricingInfo.basePrice[
              _.camelCase(type) + option.replaceAll('"', "")
            ];
          } else {
            item.unitPrice = this.pricingInfo.unitPrice[_.camelCase(type)];
            item.basePrice = this.pricingInfo.basePrice[_.camelCase(type)];
          }
          item.lineItemTotal = item.unitPrice * item.quantity;
          cart.push(item);
        }
      }
      return cart;
    },
    showPackagingSection() {
      const numberOfProducts = this.project.cart.length;
      const enablePackaging = this.settings.enablePackagingOptions;

      if (numberOfProducts > 0 && enablePackaging) {
        return true;
      } else {
        return false;
      }
    },
    individualPackagingCost() {
      let individualPackagingCostPerItem = this.settings
        .individualPackagingCost;
      let cart = this.project.cart;
      let individualPackagingTotal = 0;

      cart.map(item => {
        if (
          item.productData.productType != "swatch" &&
          item.productData.productType != "Custom Tag"
        ) {
          individualPackagingTotal +=
            individualPackagingCostPerItem * Number(item.quantity);
        }
      });

      return individualPackagingTotal;
    },
    lineItems() {
      let items = [];
      if (this.pricedCart.length == 0 && this.project.swatches.length == 0) {
        return [];
      }
      let cart = [];

      if (this.pricedCart.length > 0) {
        for (let index = 0; index < this.pricedCart.length; index++) {
          const item = this.pricedCart[index];
          // Net unit price for the line (server maps this to GraphQL `priceOverride` when
          // variantId is set — Shopify ignores originalUnitPriceWithCurrency on variant lines).
          let lineItem = {
            title: item.productData.productType,
            quantity: item.quantity,
            productId: item.shopifyProductID,
            variantId: item.shopifyVariantID,
            originalUnitPriceWithCurrency: {
              amount: Number(item.unitPrice).toFixed(2),
              currencyCode: "USD"
            },
            requiresShipping: !(item.productData.productType == "Custom Tag")
          };
          const unitSavings = Number(item.basePrice) - Number(item.unitPrice);
          const lineSavings = unitSavings * Number(item.quantity);
          if (lineSavings > 0.005) {
            lineItem.customAttributes = [
              {
                key: "Bulk savings",
                value:
                  "You saved " +
                  lineSavings.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD"
                  })
              }
            ];
          }
          items.push(lineItem);
        }
      }
      if (this.project.swatches.length > 0) {
        const swatchFulfillment = this.swatchShippingOption;
        const projectID = this.project.projectID;
        const swatchesPrice = this.swatchesTotalPrice;
        let swatches = {};
        let swatchesIncluded = "";

        if (swatchFulfillment === "digital") {
          swatches.quantity = 1;
          swatches.title = projectID + " Swatches: ";
          swatches.requiresShipping = false;
          swatches.taxable = false;
          swatches.originalUnitPriceWithCurrency = {
            amount: swatchesPrice,
            currencyCode: "USD"
          };

          items.push({
            title: `${this.settings.swatchEmailedProductLabel}`,
            quantity: 1,
            requiresShipping: false,
            taxable: false,
            originalUnitPriceWithCurrency: {
              amount: 0,
              currencyCode: "USD"
            }
          });
        } else if (swatchFulfillment === "physical") {
          swatches.quantity = 1;
          swatches.title = projectID + " Swatches: ";
          swatches.grams = 1;
          swatches.requiresShipping = true;
          swatches.taxable = true;
          swatches.originalUnitPriceWithCurrency = {
            amount: swatchesPrice,
            currencyCode: "USD"
          };
        } else {
          swatches.quantity = 1;
          swatches.title = projectID + " Swatches: ";
          swatches.grams = 1;
          swatches.requiresShipping = true;
          swatches.taxable = true;
          swatches.originalUnitPriceWithCurrency = {
            amount: swatchesPrice,
            currencyCode: "USD"
          };
        }

        for (let index = 0; index < this.project.swatches.length; index++) {
          const swatch = this.project.swatches[index];
          if (index > 0) {
            swatchesIncluded = swatchesIncluded.concat(", ");
          }
          swatchesIncluded = swatchesIncluded.concat(
            swatch.proofID + " (" + swatch.productType + ")"
          );
        }
        swatches.title += swatchesIncluded;
        items.push(swatches);
      }
      if (
        this.project.priceAdjustment.amount > 0 &&
        this.pricedCart.length > 0
      ) {
        let priceAdjustment = {
          title: this.project.priceAdjustment.label,
          price: this.project.priceAdjustment.amount,
          quantity: 1,
          requiresShipping: false,
          grams: 0
        };
        items.push(priceAdjustment);
      }
      if (this.project.setupCharge > 0 && this.project.cart.length > 0) {
        let setupCharge = {
          title: "Set Up Charge",
          originalUnitPriceWithCurrency: {
            amount: parseFloat(this.project.setupCharge).toFixed(2),
            currencyCode: "USD"
          },
          quantity: 1,
          requiresShipping: false,
          grams: 0
        };
        items.push(setupCharge);
      }
      if (this.showPackagingSection) {
        if (this.selectedPackagingOption.name == "giftBox") {
          let packagingCharge = {
            title: "Individual Kraft Gift Boxes",
            originalUnitPriceWithCurrency: {
              amount: this.selectedPackagingOption.cost,
              currencyCode: "USD"
            },
            quantity: 1,
            requiresShipping: false,
            grams: 0
          };
          items.push(packagingCharge);
        } else if (this.selectedPackagingOption.name == "minimal") {
          let packagingCharge = {
            title: "Minimal Packaging",
            originalUnitPriceWithCurrency: {
              amount: this.selectedPackagingOption.cost.toFixed(2),
              currencyCode: "USD"
            },
            quantity: 1,
            requiresShipping: false,
            grams: 0
          };
          items.push(packagingCharge);
        }
      }
      return items;
    },
    draftOrderObject() {
      let object = {
        note_attributes: [
          {
            name: "project id",
            value: this.project.projectID
          }
        ],
        line_items: this.lineItems,
        appliedDiscount: this.discountOptionsApplied
      };
      if (this.project.customShipping.label) {
        object.shipping_line = {
          price: parseInt(this.project.customShipping.amount.toFixed(2)),
          title: this.project.customShipping.label
        };
      }
      return object;
    },
    swatchesTotalPrice() {
      const swatchFulfillment = this.swatchShippingOption;
      const swatchCount = this.project.swatches.length;
      const digitalFulfillmentCost = this.settings.swatchDigitalCost;
      const shippedFulfillmentCost = this.settings.swatchShippedCost;
      let fulfillmentCost = this.settings.individualSwatchCost;

      if (swatchFulfillment === "digital") {
        fulfillmentCost = swatchCount * digitalFulfillmentCost;
      } else if (swatchFulfillment === "physical") {
        fulfillmentCost = swatchCount * shippedFulfillmentCost;
      } else {
        fulfillmentCost = swatchCount * fulfillmentCost;
      }

      return fulfillmentCost.toFixed(2);
    },
    swatchPriceLabel() {
      const swatchesPrice = this.swatchesTotalPrice;
      let swatchLabel;
      if (swatchesPrice === 0) {
        swatchLabel = "FREE";
      } else {
        swatchLabel = `$${swatchesPrice}`;
      }
      return swatchLabel;
    },
    showSwatchFulfillmentSection() {
      let showSection = this.settings.allowDigitalSwatchFulfillment;
      let hasSwatches = this.project.swatches.length > 0;
      let hasNormalProducts = this.project.cart.length > 0;

      if (showSection && hasSwatches && !hasNormalProducts) {
        return true;
      } else {
        return false;
      }
    },
    showSwatchWarning() {
      let showSection = true;
      let hasSwatches = this.project.swatches.length > 0;
      let hasNormalProducts = this.project.cart.length > 0;

      if (hasNormalProducts && hasSwatches && showSection) {
        return true;
      } else {
        return false;
      }
    },
    swatchFulfillmentSelection() {
      const fulfillmentOptions = {
        physical: "physical",
        digital: "digital"
      };
      let shippingChoice = this.onSwatchShippingSelect;

      if (shippingChoice === fulfillmentOptions.physical) {
        return fulfillmentOptions.physical;
      } else if (shippingChoice === fulfillmentOptions.digital) {
        return fulfillmentOptions.digital;
      } else {
        return "No selection";
      }
    },
    subTotalRecalculation() {
      const currentTotal = this.pricingInfo.subTotal;
      const swatchCost = this.settings.swatchShippedCost;
      const numberOfSwatches = this.project.swatches.length;
      const swatchesTotal = this.swatchesTotalPrice;

      let newTotal;

      if (swatchesTotal == 0) {
        newTotal = currentTotal - swatchCost * numberOfSwatches;
      } else {
        newTotal = currentTotal;
      }
      return newTotal;
    },
    subtotalCalculation() {
      let discount = this.discountDataRenderedInCart;
      let discountType = this.getDiscountType;
      let discountsEnabled = this.discountsEnabled;
      let discountAmount = 0;
      let discountValue = discount.value || 0;
      let setupCharge = Number(this.project.setupCharge) || 0;
      let subtotalWithoutDiscount = Number(this.subTotalRecalculation);

      if (discount.amountWithCurrency && discount.amountWithCurrency.amount) {
        discountAmount = discount.amountWithCurrency.amount;
      }

      if (discountsEnabled) {
        if (discountType === "PERCENTAGE") {
          return subtotalWithoutDiscount - this.discountCalculation;
        } else if (discountType === "FIXED_AMOUNT") {
          if (discountAmount) {
            return subtotalWithoutDiscount - discountAmount;
          } else {
            return subtotalWithoutDiscount - discountAmount;
          }
        }
      } else {
        return subtotalWithoutDiscount;
      }
    },
    discountsEnabled() {
      let developmentDiscountsFlag = false;
      let discountsEnabledOnContentful = this.discountSettings.enableDiscounts;

      if (developmentDiscountsFlag) {
        return true;
      } else {
        return discountsEnabledOnContentful;
      }
    },
    discountDataRenderedInCart() {
      let discount = this.discountOptionsApplied;
      return discount;
    },
    discountCalculation() {
      let discount = this.discountOptionsApplied;
      let discountType = this.getDiscountType;
      let subtotalWithoutDiscount = Number(this.subTotalRecalculation);
      let discountedAmount = 0;
      if (discountType === "PERCENTAGE") {
        discountedAmount = (
          subtotalWithoutDiscount *
          (discount.value / 100)
        ).toFixed(2);
      } else if (discountType === "FIXED_AMOUNT") {
        discountedAmount = Number(discount.value).toFixed(2);
      }
      return discountedAmount;
    },
    discountThresholdCalculationRenderer() {
      let discountsEnabled = this.discountsEnabled;
      let setupCharge = this.project.setupCharge || 0;
      let cartSubtotal =
        Number(this.pricingInfo.productSubTotal) + Number(setupCharge);
      let discountType = this.getDiscountType;
      let amountToNextTier = this.calculateDifferenceToNextTier;
      let lowestTier = this.discountSettings.tierOneThreshold;
      let renderedText = "";
      let amountRounded = parseFloat(amountToNextTier).toFixed(2);
      let noTierReachedText = String(
        this.discountSettings.noTierReachedCartLabel
      );
      let notReachedText = String(
        this.discountSettings.tiersNotReachedCartLabel
      );
      let topTierReachedText = this.discountSettings.topTierReachedCartLabel;
      let contentfulVariable = "{{amountRounded}}";

      if (discountsEnabled && discountType === "FIXED_AMOUNT") {
        if (cartSubtotal < lowestTier) {
          renderedText = this.replaceContentfulVariable(
            noTierReachedText,
            contentfulVariable,
            amountRounded
          );
        } else if (amountToNextTier === 0) {
          renderedText = topTierReachedText;
        } else {
          renderedText = this.replaceContentfulVariable(
            notReachedText,
            contentfulVariable,
            amountRounded
          );
        }
      }

      return renderedText;
    },
    calculateDifferenceToNextTier() {
      let discountsEnabled = this.discountsEnabled;
      let discountType = this.getDiscountType;
      let setupCharge = this.project.setupCharge || 0;
      let subtotalWithoutDiscount =
        Number(this.pricingInfo.productSubTotal) + Number(setupCharge);
      let tiers = {
        one: Number(this.discountSettings.tierOneThreshold),
        two: Number(this.discountSettings.tierTwoThreshold),
        three: Number(this.discountSettings.tierThreeThreshold),
        four: Number(this.discountSettings.tierFourThreshold)
      };
      let amountUntilNextTier = 0;

      if (discountsEnabled && discountType === "FIXED_AMOUNT") {
        if (tiers.one && subtotalWithoutDiscount < tiers.one) {
          amountUntilNextTier = tiers.one - subtotalWithoutDiscount;
        } else if (tiers.two && subtotalWithoutDiscount < tiers.two) {
          amountUntilNextTier = tiers.two - subtotalWithoutDiscount;
        } else if (tiers.three && subtotalWithoutDiscount < tiers.three) {
          amountUntilNextTier = tiers.three - subtotalWithoutDiscount;
        } else if (tiers.four && subtotalWithoutDiscount < tiers.four) {
          amountUntilNextTier = tiers.four - subtotalWithoutDiscount;
        } else {
          amountUntilNextTier = 0;
        }
        return amountUntilNextTier;
      }
    },
    getDiscountType() {
      let discountBoolean = this.discountSettings.discountType;
      let discountType = "";

      if (discountBoolean === true) {
        discountType = "PERCENTAGE";
      } else if (discountBoolean === false) {
        discountType = "FIXED_AMOUNT";
      }

      return discountType;
    },
    discountOptionsApplied() {
      let setupCharge = this.project.setupCharge || 0;
      let cartAmount =
        Number(this.pricingInfo.productSubTotal) + Number(setupCharge);
      let discountsEnabled = this.discountsEnabled;
      let discountType = this.getDiscountType;
      let discount = {};

      let tierOne = {
        title: String(this.discountSettings.tierOneLabel),
        threshold: Number(this.discountSettings.tierOneThreshold),
        value: Number(this.discountSettings.tierOneDiscountAmount)
      };
      let tierTwo = {
        title: String(this.discountSettings.tierTwoLabel),
        threshold: Number(this.discountSettings.tierTwoThreshold),
        value: Number(this.discountSettings.tierTwoDiscountAmount)
      };
      let tierThree = {
        title: String(this.discountSettings.tierThreeLabel),
        threshold: Number(this.discountSettings.tierThreeThreshold),
        value: Number(this.discountSettings.tierThreeDiscountAmount)
      };
      let tierFour = {
        title: String(this.discountSettings.tierFourLabel),
        threshold: Number(this.discountSettings.tierFourThreshold),
        value: Number(this.discountSettings.tierFourDiscountAmount)
      };
      let percentageDiscount = {
        title: String(this.discountSettings.percentageDiscountLabel),
        value: Number(this.discountSettings.percentageDiscountAmount)
      };

      if (discountsEnabled) {
        if (discountType === "PERCENTAGE") {
          discount = {
            title: percentageDiscount.title,
            valueType: "PERCENTAGE",
            value: percentageDiscount.value,
            amountWithCurrency: {
              amount: Number(
                (cartAmount * percentageDiscount.value) / 100
              ).toFixed(2),
              currencyCode: "USD"
            }
          };
        } else if (discountType === "FIXED_AMOUNT") {
          if (tierFour.threshold && cartAmount >= tierFour.threshold) {
            discount = {
              title: tierFour.title,
              valueType: "FIXED_AMOUNT",
              value: tierFour.value,
              amountWithCurrency: {
                amount: Number(tierFour.value),
                currencyCode: "USD"
              }
            };
          } else if (tierThree.threshold && cartAmount >= tierThree.threshold) {
            discount = {
              title: tierThree.title,
              valueType: "FIXED_AMOUNT",
              value: tierThree.value,
              amountWithCurrency: {
                amount: Number(tierThree.value),
                currencyCode: "USD"
              }
            };
          } else if (tierTwo.threshold && cartAmount >= tierTwo.threshold) {
            discount = {
              title: tierTwo.title,
              valueType: "FIXED_AMOUNT",
              value: tierTwo.value,
              amountWithCurrency: {
                amount: Number(tierTwo.value),
                currencyCode: "USD"
              }
            };
          } else if (tierOne.threshold && cartAmount >= tierOne.threshold) {
            discount = {
              title: tierOne.title,
              valueType: "FIXED_AMOUNT",
              value: tierOne.value,
              amountWithCurrency: {
                amount: Number(tierOne.value),
                currencyCode: "USD"
              }
            };
          } else {
            discount = {};
          }
        }
      } else {
        discount = {};
      }
      return discount;
    }
  },
  watch: {
    cartLink() {
      setTimeout(() => {
        window.location = this.cartLink;
      }, 1000);
    }
  },
  methods: {
    focusDialog(event) {
      if (event.target === event.currentTarget) {
        this.$refs.dialog.focus();
      }
    },
    filterFirst(options) {
      const obj = options;
      Object.keys(options).forEach(key => {
        if (options[key] === "") {
          delete obj[key];
        }
      });
      return obj;
    },
    removeItem(index) {
      this.$emit("remove-cart-item", index);
    },
    removeSwatch(index) {
      this.$emit("remove-swatch", index);
    },
    async createDraftOrder() {
      let swatchesIncluded = this.project.swatches.length > 0;
      if (
        this.selectedPackagingOption.selectionMade === true &&
        this.showPackagingSection &&
        this.swatchShippingOption
      ) {
        let response = await ProjectsService.createDraftOrder({
          order: this.draftOrderObject
        });

        this.cartLink =
          response.data.draftOrder.draftOrderCreate.draftOrder.invoiceUrl;
      } else if (
        (this.showPackagingSection === true &&
          this.selectedPackagingOption.selectionMade === false) ||
        (!this.swatchShippingOption && swatchesIncluded > 0)
      ) {
        if (
          !this.swatchShippingOption &&
          swatchesIncluded > 0 &&
          this.showSwatchFulfillmentSection
        ) {
          this.showSwatchCheckoutError = true;
        }

        if (
          this.showPackagingSection === true &&
          this.selectedPackagingOption.selectionMade === false
        ) {
          this.showPackagingCheckoutError = true;
        }

        if (
          this.selectedPackagingOption.selectionMade === true &&
          this.showSwatchFulfillmentSection === false
        ) {
          let response = await ProjectsService.createDraftOrder({
            order: this.draftOrderObject
          });

          this.cartLink =
            response.data.draftOrder.draftOrderCreate.draftOrder.invoiceUrl;
        }

        if (
          this.showSwatchFulfillmentSection === false &&
          this.showPackagingSection === false
        ) {
          let response = await ProjectsService.createDraftOrder({
            order: this.draftOrderObject
          });

          this.cartLink =
            response.data.draftOrder.draftOrderCreate.draftOrder.invoiceUrl;
        }
      } else {
        if (
          this.showPackagingSection === false ||
          this.showSwatchCheckoutError === false
        ) {
          this.showPackagingCheckoutError = false;
          let response = await ProjectsService.createDraftOrder({
            order: this.draftOrderObject
          });
          this.cartLink =
            response.data.draftOrder.draftOrderCreate.draftOrder.invoiceUrl;
        } else {
          this.showPackagingCheckoutError = true;
        }
      }
    },
    selectPackage(selectionType, event) {
      const minimalSelector = this.$refs.minimal;
      const giftBoxSelector = this.$refs.giftBox;
      const minimalPackagingCost = this.settings.minimalPackagingCost;
      const individualPackagingCost = this.individualPackagingCost;

      if (selectionType === "giftBox") {
        giftBoxSelector.checked = true;
        giftBoxSelector.value = true;
        this.selectedPackagingOption.name = "giftBox";
        this.selectedPackagingOption.cost = individualPackagingCost;
        this.selectedPackagingOption.selectionMade = true;

        this.$emit("select-packaging", individualPackagingCost);

        if (minimalSelector.checked == true) {
          minimalSelector.checked = false;
          minimalSelector.value = false;
        }
      } else {
        minimalSelector.checked = true;
        minimalSelector.value = true;
        this.selectedPackagingOption.name = "minimal";
        this.selectedPackagingOption.cost = minimalPackagingCost;
        this.selectedPackagingOption.selectionMade = true;

        this.$emit("select-packaging", minimalPackagingCost);

        if (giftBoxSelector.checked == true) {
          giftBoxSelector.checked = false;
          giftBoxSelector.value = false;
        }
      }

      this.showPackagingCheckoutError = false;
      return selectionType;
    },
    onSwatchShippingSelect(event) {
      let swatchShippingOptionSelected = event.target.value;
      this.swatchShippingOption = swatchShippingOptionSelected;
      this.showSwatchCheckoutError = false;
      return swatchShippingOptionSelected;
    },
    clearCart() {
      this.$emit("clear-cart");
    },
    replaceContentfulVariable(originalString, stringToMatch, replacementValue) {
      return originalString.replace(stringToMatch, replacementValue);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/design-portal/Cart.vue